import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showWarningToast = ({ title, message }) => {
  toast.warning(
    <div>
      <strong>{title}</strong>
      <p>{message}</p>
    </div>,
    {
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastClassName: "bg-warning text-dark",
      bodyClassName: "text-center",
      style: { width: "300px" }, // Adjust the width as needed
    }
  );
};

export const showSuccessToast = ({ title, message }) => {
  toast.success(
    <div>
      <strong>{title}</strong>
      <p>{message}</p>
    </div>,
    {
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastClassName: "bg-success text-dark",
      bodyClassName: "text-center",
      style: { width: "300px" }, // Adjust the width as needed
    }
  );
};

export const showQuestionToast = ({ title, message, onConfirm, onCancel }) => {
  const CustomToast = ({ closeToast }) => (
    <div>
      <strong>{title}</strong>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        <button
          onClick={() => {
            onConfirm(); // Trigger confirm action
            closeToast(); // Close the toast
          }}
          style={{ marginRight: '10px', backgroundColor: 'lightgreen', width: "35%"}}
        >
          Da
        </button>
        <button
          onClick={() => {
            onCancel(); // Trigger cancel action
            closeToast(); // Close the toast
          }}
          style={{ marginRight: '10px', backgroundColor: 'lightgray', width: "35%" }}
        >
          Ne
        </button>
      </div>
    </div>
  );

  // Show custom toast
  toast(<CustomToast />, {
    autoClose: false,  // Keep the toast open until user takes action
    closeOnClick: false,
    draggable: false,
    hideProgressBar: true,
    position: "top-center", // Change as per your preference
    pauseOnHover: true,
    style: { width: '80%' } // Adjust size
  });
};
